import toPercent from '@utils/toPercent';

const THRESHOLD = 75;
export default function isBelowMileageThreshold(
    evaluatedMileage: number | null,
    totalMileage: number | undefined,
) {
    if (evaluatedMileage === null || totalMileage === undefined) return true;

    return toPercent(evaluatedMileage, totalMileage) < THRESHOLD;
}
